import { render, staticRenderFns } from "./identifyControl.vue.js?vue&type=template&id=2006450c&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./identifyControl.vue?vue&type=template&id=2006450c&scoped=true"
import script from "./identifyControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./identifyControl.vue?vue&type=script&lang=js"
export * from "./identifyControl.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./identifyControl.vue?vue&type=script&lang=js"
import style0 from "./identifyControl.vue.scss?vue&type=style&index=0&id=2006450c&prod&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./identifyControl.vue?vue&type=style&index=0&id=2006450c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006450c",
  null
  
)

export default component.exports